/**
 * @author Adalto Junior adaltojunior@sagaranatech.com
 * DATE 16/01/2013
 *  Time: 09:00
 */


Greenmile.Calculos = Greenmile.Calculos || {};

Greenmile.Calculos.GeneralFunctions = function () {

    this.calculateAverageSpeed = function (distanceInMetters, timeInMillis) {

        var unitSystem = Monet.Session.User.unitSystem;
        var unitSystemStr = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.kilometersPerHour");
        var averageSpeed = 0;

        if (distanceInMetters &&
            timeInMillis &&
            distanceInMetters !== 0 &&
            timeInMillis !== 0) {

            var formatter = new Monet.Format.DISTANCE(distanceInMetters);

            var time = timeInMillis / 3600000;
            var distance = 0;

            if (unitSystem === "NON_METRIC") {

                distance = formatter.convertMetersToMiles().getValue();

            } else {

                distance = formatter.convertMetersToKilometers().getValue();

            }

            averageSpeed = distance / time;
            averageSpeed.toFixed(2);
        }

        if (unitSystem === "NON_METRIC") {
            unitSystemStr = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.milesPerHour");
        }

        return new Monet.Format.DECIMAL(averageSpeed).format().getValue() + " " + unitSystemStr;

    };

    this.formatDistanceTotal = function (metters) {

        var error         = null,
            result        = 0,
            unitSystemStr = "",
            unitSystem    = null,
            i18n          = null;

        try {

            unitSystem = Monet.Session.User.unitSystem;
            i18n = Monet.I18n;

            if (typeof metters !== "undefined") {

                var formatter = new Monet.Format.DISTANCE(metters);

                if (unitSystem === "METRIC") {

                    result = formatter.convertMetersToKilometers().format().getValue();
                    unitSystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.kilometers");

                } else {

                    result = formatter.convertMetersToMiles().format().getValue();
                    unitSystemStr = i18n.getResourcesByKey("Greenmile.UnitMetrics.miles");

                }

            }

            return result + " " + unitSystemStr;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on format distance total.");
            error.console();

        }
    };

    this.getUnitSystemToColumnGrid = function () {

        var unitSystem = Monet.Session.User.unitSystem;
        var strUnitySystem = "";

        if (unitSystem === "METRIC") {
            strUnitySystem = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.kilometers");
        } else {
            strUnitySystem = Monet.I18n.getResourcesByKey("Greenmile.UnitMetrics.miles");
        }

        return strUnitySystem;

    };

    /*
     Function usada no template events
     */
    this.getUnitySystemMettersOrFeets = function () {
        var unitSystem = Monet.Session.User.unitSystem;
        var strUnitySystem = "";
        if (unitSystem === "METRIC") {
            strUnitySystem = Monet.I18n
                .getResourcesByKey("Greenmile.UnitMetrics.meters");
        } else {
            strUnitySystem = Monet.I18n
                .getResourcesByKey("Greenmile.UnitMetrics.feet");
        }
        return strUnitySystem;
    };

    this.formatDistanceOnKmOrMilles = function (metters) {

        var unitSystem = Monet.Session.User.unitSystem;
        var value = 0;

        if (typeof (metters) !== "undefined") {

            var formatter = new Monet.Format.DISTANCE(metters);

            if (unitSystem === "METRIC") {
                value = formatter.convertMetersToKilometers().getValue();
            } else {
                value = formatter.convertMetersToMiles().getValue();
            }

        }

        return value;
    };

};